import * as actionTypes from 'store/actions/actionTypes';
import { calcOrigin } from 'store/utility';

// brand then id will be -2
export const FILTER_BY_PRODUCT_TYPES = {
  6: [-2, 6, 4, 3, 5, 10],
  3: [6, 3],
  2: [-2, 6, 3, 2, 5],
  1: [6, 4, 3, 2, 7, 8, 5, 9],
  4: [6, 3],
  5: [-2, 4],
};

export const filterIdByProductTypes = productTypes => {
  let filters = [];
  productTypes.forEach(productType => {
    filters = [...filters, ...FILTER_BY_PRODUCT_TYPES[productType]];
  });

  // remove duplicates
  return [...new Set(filters)];
};

export const filterByProductTypes = (filters, productTypes) => {
  const filterIds = filterIdByProductTypes(productTypes);
  return filters.filter(filter => filterIds.includes(filter.id));
};

export const PRODUCT_TYPES = [
  {
    id: 6,
    title: 'Countertop',
  },
  {
    id: 3,
    title: 'Mosaic',
  },
  {
    id: 2,
    title: 'Stone',
  },
  {
    id: 1,
    title: 'Tiles',
  },
  {
    id: 5,
    title: 'Vinyl',
  },
  {
    id: 4,
    title: 'Wood',
  },
];

const initState = {
  loading: false,
  all: {},
  tiles: [],
  stone: [],
  mosaic: [],
  wood: [],
  vinyl: [],
  countertop: [],
  filterTypology: [],
};

/*
    - mapProductsToState returns new state
    - maps incoming products response to state
    - products response is a little confusing
    - incoming product response json example:
    {
        tiles: {
            products: [
                ...product,
                ...product
            ]
        }
    }
*/
const mapProductsToState = (products, state) => {
  const key = Object.keys(products)[0];
  const value = Object.values(products)[0];

  let newState = { ...state };
  newState['loading'] = false;
  newState[key] = [...value['products']];
  return newState;
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PRODUCTS_START:
      return { ...state, loading: true };
    case actionTypes.FETCH_PRODUCTS_END:
      const { products } = action;
      return mapProductsToState(products, state);
    case actionTypes.FETCH_ALL_PRODUCTS_END:
      const { allProducts } = action;
      let newState = { ...state, loading: false, all: {...allProducts}, ...allProducts };
      return newState;
    case actionTypes.UPDATE_PRODUCT_START:
      return { ...state, loading: true };
    case actionTypes.UPDATE_PRODUCT_END:
      return { ...state, loading: false };
    case actionTypes.GET_FILTER_TYPOLOGY_END:
      const { filterTypology } = action;
      return { ...state, filterTypology };
    default:
      return state;
  }
};

export const parse = products => {
  const values = Object.values(products);
  // TODO: WHEN PAUL PUSHES REMOVE !values[1] to remove check of product is null
  if (values[0] || values[1].length === 0) return products;
  // filter out loading attribute
  const productKeys = ['tiles', 'stone', 'mosaic', 'wood', 'vinyl', 'countertop'];
  const newProducts = { ...products };
  for (const key of productKeys) {
    // add to new attribute instead of overwritting..
    newProducts[key] = products[key].map(e => {
      if (e['price_cents'] === 0) {
        e['price_format'] = '$0.00';
      } else if (typeof e['price_cents'] === typeof 0) {
        e['price_format'] = `${calcOrigin(e['price_cents'] / 100, 'cents')}`;
      }

      if (e['price_sale'] === 0) {
        e['price_sale_format'] = '';
      } else if (typeof e['price_sale'] === typeof 0) {
        e['price_sale_format'] = `${calcOrigin(e['price_sale'] / 100, 'cents')}`;
      }
      return e;
    });
  }
  return newProducts;
};



// WEBPACK FOOTER //
// ./src/store/reducers/product.js